export const DICTATION_CUSTOM_VOCABULARY_KEY = 'dictation-custom-vocabulary';
